import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import TableCasino from '../../components/table';
import Title from '../../../../../@casino/ui/title';
import { setGetWithdrawalsAwaiting } from '../../store/thunk/setGetWithdrawalsAwaiting';
import {useStyles, getRows, columns} from './helper';
import { setPostUpdateStatus } from '../../store/thunk/setPostUpdateStatus';
import Dialog from '@material-ui/core/Dialog';
import ModalWithdrawals from '../../components/modal';
import { setGetAlfakitBalance } from '../../store/thunk/setGetAlfakitBalance';

const ReportUnconfirmed = () => {
    const dispatch = useDispatch();
    const classes = useStyles();
    const [search, setSearch] = React.useState();
    const [error, setError] = React.useState('')
    const [isPayout, setIsPayout] = React.useState(false);

    React.useEffect(() => {
        dispatch(setGetWithdrawalsAwaiting({
            page: 1,
            rowsPerPage: 10
        }))
        dispatch(setGetAlfakitBalance());
    }, []);

    const withdrawalsAwaiting = useSelector(state => state.withdrawalsAwaiting.list);
    const balance = useSelector(state => state.withdrawalsAwaiting.balance);

    const rows = React.useMemo(() => getRows(withdrawalsAwaiting.data), [withdrawalsAwaiting.data]);

    return (
        <div style={{padding: 20, paddingTop: 0}}>
            <Title label="Неподтвержденные операции" labelBtn="Вывести средства" button={() => setIsPayout(true)}/>
            <div className={classes.wrap} style={{
                display: 'flex',
                gap: 12,
                flexWrap: 'wrap',
                padding: '10px'
            }}>
                {
                    balance?.map((item) => Boolean(item.amount) && <div style={{padding: '5px 10px', background: 'rgb(255, 195, 36)', borderRadius: 8}}><span style={{color: '#000'}}>{item.currency} {item.amount} (HOLD: {item.holdAmount})</span></div>)
                }
            </div>
            <div className={classes.wrap}>
                <input 
                    type="text"
                    placeholder="Поиск"
                    className={classes.search}
                    value={search}
                    onChange={(v) => {
                        dispatch(setGetWithdrawalsAwaiting({
                            page: 1,
                            rowsPerPage: 10,
                            search: v.target.value
                        }));
                        setSearch(v.target.value);
                    }}
                />
            </div>
            <div className={classes.wrapBlock}>
                <TableCasino 
                    pagination
                    allPage={withdrawalsAwaiting.countPage}
                    width={1300}
                    perPage={10}
                    columns={columns}
                    rows={rows}
                    updateStatus={(params) => {
                        dispatch(setPostUpdateStatus(params, setError))
                    }}
                    changePage={(v) => dispatch(setGetWithdrawalsAwaiting({
                        page: +v.page+1,
                        rowsPerPage: v.rowsPerPage,
                        search,
                    }))}
                    changeRowsPerPage={(v) => dispatch(setGetWithdrawalsAwaiting({
                        page: +v.page + 1,
                        rowsPerPage: v.rowsPerPage,
                        search,
                    }))}
                /> 
            </div>
            <Dialog onClose={() => setError('')} open={error !== ''}>
                <div style={{padding: 20, display: 'flex', flexDirection: 'column'}}>
                    <span>{error}</span>
                    <span style={{
                        marginTop: 12,
                        padding: '10px',
                        background: 'rgb(255, 195, 36)',
                        borderRadius: '4px',
                        cursor: 'pointer',
                        color: 'rgb(20, 27, 51)',
                        display: 'flex',
                        justifyContent: 'center'
                    }}
                    onClick={() => setError('')}
                    >ОК</span>
                </div>
            </Dialog>
            {
                isPayout && <ModalWithdrawals setIsPayout={setIsPayout} />
            }
        </div>

    )
}

export default ReportUnconfirmed;